/*
  Loads TikTok player iframes automatically once their card scrolls within
  about 200px of the viewport, instead of waiting for a click. Scoped only to
  <deferred-media data-platform="tiktok"> elements (the "As Seen On TikTok"
  section and the inlined Bobby Solez product-page embed) so other
  deferred-media usages in the theme (e.g. hero videos) keep their existing
  click-to-load behavior untouched.

  Reuses the existing deferred-media poster/click wiring from global.js
  (DeferredMedia class) by dispatching a real click on the poster button,
  so the iframe (already carrying autoplay=1&muted=1&loop=1 in its src) is
  cloned from its <template> and appended exactly as it would be on a
  manual click. The poster image/placeholder stays visible, and the
  embed wrapper keeps its fixed aspect-ratio, until that swap happens, so
  there is no layout shift.
*/
document.addEventListener('DOMContentLoaded', () => {
  const tiktokEmbeds = document.querySelectorAll('deferred-media[data-platform="tiktok"]');
  if (!tiktokEmbeds.length || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        if (el.hasAttribute('loaded')) return;
        const poster = el.querySelector('[id^="Deferred-Poster-"]');
        if (poster) poster.click();
      });
    },
    { rootMargin: '200px 0px', threshold: 0 }
  );

  tiktokEmbeds.forEach((el) => observer.observe(el));
});
